import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';

import staffAugmentationAnimation from '@images/animations/staffAugmentationAnimation.json';
import * as styles from './Header.module.scss';
import Lottie from 'lottie-react';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-lg-6 mb-4">
						<h1
							className={classNames(
								styles.header,
								'font-size-large pb-2 mb-3 mt-0'
							)}
						>
							Staff Augmentation
						</h1>
						<p className="font-size-sm pr-2 pr-sm-4 pr-md-0">
							Our specialists can help with your projects by working as part of
							your team. It is an outsourcing model that lets you augment your
							existing team with external developers. Your in-house development
							team collaborates with the developers provided by your IT staff
							augmentation partner, onsite, as an additional remote development
							team, or in a hybrid setting. We work in a particular tech stack
							but have a network of trusted partners for other technologies.
						</p>
					</div>
					<div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
						<Lottie animationData={staffAugmentationAnimation} loop={true} />
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
